import React from 'react';
import styled from 'styled-components';
import IconLink from 'components/IconLink';
import useI18n from 'i18n/useI18n';
import FormCard from 'containers/Form/FormCard';
import FloatingButton from '../FloatingButton';
import { ACTIONS } from './Reducer';
import Image from './Sections/Image';
import Details from './Sections/Details';
import Settings from './Sections/Settings';
import Icon from './Sections/Icon';
import CATEGORY_KEYS from './keys';
import Availability from './Sections/Availability';
import FormTitle from 'pages/MenuItems/components/FormTitle';

const Container = styled.div`
    width: 100%;
    max-width: 100%;
    height: 100%;
    max-height: 100%;
    overflow: scroll;
`;

const Layout = styled.div`
    width: 100%;
    min-height: 100%;
    margin-bottom: 80px;
    position: relative;
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: flex-start;
`;

const CategoryForm = ({ formData, dispatch, submit, title, button }) => {
    const { translate } = useI18n();
    
    const handleItemInfo = (field, value) => {
        const newField = { [field]: value };
        dispatch(ACTIONS.ITEM_INFO, newField);
    };
    
    return (
        <Container>
            <Layout>
                <IconLink to={'/menu/categories'}>{translate('Back to Categories')}</IconLink>
                <div style={{ height: '18px' }} />
                <FormCard>
                    <form style={{ width: '100%' }} onSubmit={submit}>
                        <FormTitle style={{ fontSize: '1.5rem', lineHeight: 'normal', textAlign: 'center' }}>{title}</FormTitle>
                        <Image formData={formData} handleItemInfo={handleItemInfo} />             
                        <Icon formData={formData} dispatch={dispatch} />
                        <Availability formData={formData} dispatch={dispatch}/>
                        <Details formData={formData} dispatch={dispatch} handleItemInfo={handleItemInfo} />
                        <Settings formData={formData} dispatch={dispatch} />
                        <FloatingButton disabled={!formData[CATEGORY_KEYS.HAS_CHANGED]} type={'submit'}>{button}</FloatingButton>
                    </form>
                </FormCard>
            </Layout>
        </Container>
    );
};

export default CategoryForm;
